export const EMPTY_DATE_PLACEHOLDER =
  '<span class="year">&nbsp;</span>年<span class="month">&nbsp;</span>月<span class="day">&nbsp;</span>日'

const JP_DATE_PATTERN = 'yyyy年 m月 d日'

export type DateFormatFn = (
  date: Date | string | undefined,
  format: string
) => string

export function formatPreviewCreateDate(
  createDate: Date | string | undefined | null,
  dateFormat: DateFormatFn,
  emptyMode: 'today' | 'placeholder'
): string {
  if (!createDate) {
    if (emptyMode === 'today') {
      return dateFormat(new Date(), JP_DATE_PATTERN)
    }
    return EMPTY_DATE_PLACEHOLDER
  }
  return dateFormat(createDate, JP_DATE_PATTERN)
}

export function formatPreviewRetirementDate(
  retirementDate: Date | string | undefined | null,
  dateFormat: DateFormatFn
): string {
  if (!retirementDate) {
    return EMPTY_DATE_PLACEHOLDER
  }
  return dateFormat(retirementDate, JP_DATE_PATTERN)
}
